var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96189 11.0224C5.28253 11.0224 3.0625 8.57304 3.0625 5.51126C3.0625 2.44948 5.28253 0 7.96189 0C10.6412 0 12.8613 2.44948 12.8613 5.51126C12.8613 8.57304 10.6412 11.0224 7.96189 11.0224ZM7.96189 1.22479C5.89496 1.22479 4.28735 3.21492 4.28735 5.51126C4.28735 7.80759 5.89496 9.79773 7.96189 9.79773C10.0288 9.79773 11.6364 7.80759 11.6364 5.51126C11.6364 3.21492 10.0288 1.22479 7.96189 1.22479Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3118 19.3658C14.929 19.3658 14.6994 19.1361 14.6994 18.7534V14.6201C14.6994 12.3237 12.8621 10.4867 10.5655 10.4867H10.1827C9.79998 10.4867 9.57031 10.257 9.57031 9.87426C9.57031 9.49154 9.79998 9.26196 10.1827 9.26196H10.642C13.5511 9.26196 16.0007 11.7114 16.0007 14.6201V18.7534C15.9242 19.1361 15.618 19.3658 15.3118 19.3658Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.612436 19.3658C0.229672 19.3658 0 19.1361 0 18.7534V14.6201C0 11.7114 2.44969 9.26196 5.3587 9.26196H5.81802C6.20078 9.26196 6.43043 9.49154 6.43043 9.87426C6.43043 10.257 6.20078 10.4867 5.81802 10.4867H5.3587C3.06211 10.4867 1.22485 12.3237 1.22485 14.6201V18.7534C1.22485 19.1361 0.918648 19.3658 0.612436 19.3658Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.cc10bb8f9b69439f00c7d779c0940f00.svg";
export { ForwardRef as ReactComponent };